import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Report } from '../models/report';
import { Observable } from 'rxjs';
import { Area } from '../models/area';
import { Student } from '../models/student';
import { DownloadService } from '../services/download.service';
import { Comment } from '../models/comment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map } from 'rxjs/operators';
import { CommentService } from '../services/comment.service';
import { StudentService } from '../services/student.service';
import { ReportService } from '../services/report.service';
import { AreaService } from '../services/area.service';
import { JsonPipe } from '@angular/common';

@Component({
    selector: 'app-score',
    templateUrl: './score.component.html',
    styleUrls: ['./score.component.css'],
    standalone: false
})
export class ScoreComponent implements OnInit {

  //reportDoc: AngularFirestoreDocument<Report>;
  report$: Observable<Report>;
  listOfAreas$: Observable<any[]>
  listOfAreas: any;
  student$: Observable<Student>;
  comment: Comment = new Comment();
  student: Student;
  report: Report;

  constructor(private route: ActivatedRoute,
    //private db: AngularFirestore,
    private matSnackBar: MatSnackBar,
    private studentService: StudentService,
    private areaService: AreaService,
    private reportService: ReportService,
    private commentService: CommentService,
    private downloadService: DownloadService) {
  }

  async ngOnInit() {

    console.debug('ScoreComponent - ngOnInit');
    this.comment = new Comment();
    this.getStudentInfo();
    this.getReportInfo();
    await this.getScores();
    this.getComment();
  }

  downloadFile() {
    let secId = this.route.snapshot.params['secId'];
    let repId = this.route.snapshot.params['repId'];
    let studentId = this.route.snapshot.params['studentId'];

    //console.log('download file');
    this.downloadService.getFile(secId, repId, studentId);
  }

  async getComment() {

    let sectionId = this.route.snapshot.params['secId'];
    let reportId = this.route.snapshot.params['repId'];
    let studentId = this.route.snapshot.params['studentId'];

    this.comment = await this.commentService.readAsync(sectionId, reportId, studentId);
    console.log('Fetched comment:', this.comment);
    //Versión anterior a Firestore Modular
    // this.db.doc<Comment>('comments/' + sectionId + '-' + reportId  + '-' + studentId)
    // .valueChanges()
    // .subscribe(a => {

    //   if (a != null)
    //     this.comment = a as Comment
    // });

  }

  async saveComment(event: any) {

    let sectionId = this.route.snapshot.params['secId'];
    let reportId = this.route.snapshot.params['repId'];
    let studentId = this.route.snapshot.params['studentId'];

    console.debug('ScoreComponent - saveComment - event:', event.target.value);
    try
    {
      console.debug('ScoreComponent - saveComment:', this.comment);
      console.log('Saving comment:', this.comment.text);
      console.log('sectionId:', sectionId);
      console.log('reportId:', reportId);
      console.log('studentId:', studentId);

        await this.commentService.createOrUpdateAsync(sectionId, reportId, studentId, event.target.value);

        this.matSnackBar.open('Se grabó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 1000,
          });
    }
    catch (error) {
      console.error('Error saving comment:', error);
      alert('Error saving comment');

    }


    //Versión anterior a Firestore Modular
    // this.db.doc<Comment>('comments/' + sectionId + '-' + reportId  + '-' + studentId)
    // .set({
    //   sectionId: sectionId,
    //   reportId: reportId,
    //   studentId: studentId,
    //   text: this.comment.text
    // })
    // .then(a => {
    //   this.matSnackBar.open('Se grabó con éxito', "Close", {
    //     verticalPosition: "bottom",
    //     duration: 1000,
    //   });

    // })
  }

  async getScores() {
    let secId = this.route.snapshot.params['secId'];
    let repId = this.route.snapshot.params['repId'];
    let studentId = this.route.snapshot.params['studentId'];

    console.log('score - secId:', secId);
    console.log('score - repId:', repId);
    console.log('score - studentId:', studentId);

    // /sections/2018-2/students/7C2FCpfCSpd95dpqE78o
    //Verson anterior a Firestore Modular
    //this.student$ = this.db.doc<Student>('sections/' + secId + '/students/' + studentId).valueChanges()

    ///sections/2018-2/templates/first/areas
    ///sections/2018-2/templates/first/areas/kS1AhujLDYEZoabj9UJs/items
    //Version anterior a Firestore Modular
    // this.reportDoc = this.db.doc<Report>('sections/' + secId + '/templates/' + repId);
    // this.report$ = this.reportDoc.valueChanges();

    //Este bloque no se usa.
    // const areaList = [];

    // this.reportDoc.collection<Area>('areas').snapshotChanges().forEach(a => {
    //   a.forEach(b => {
    //     areaList.push({
    //     'name': b.payload.doc.data().name,
    //     'order': b.payload.doc.data().order
    //   })
    //   })
    // })

    // console.log('areaList', areaList);

    this.listOfAreas = await this.areaService.readSnaphotsByReportId(secId, repId);
    console.log('listOfAreas', this.listOfAreas);
    //Versión anterior a Firestore Modular
    // this.listOfAreas$ = this.reportDoc.collection<Area>('areas', ref => {
    //   return ref.orderBy("date", "asc")
    // })
    // .snapshotChanges()
    // .pipe(
    //   map(actions => {
    //     return actions.map(a => {
    //         const data = a.payload.doc.data() as Report
    //         const id = a.payload.doc.id;
    //         return { id, data }
    //     })
    //   })
    // )


  }

  async getStudentInfo() {
    let secId = this.route.snapshot.params['secId'];
    let studentId = this.route.snapshot.params['studentId'];

    // console.log('getStudentInfo - secId:', secId);
    // console.log('getStudentInfo - studentId:', studentId);

    try {
      this.student = await this.studentService.readByIdAsync(secId, studentId);
      console.log('Student info:', this.student);
    }
    catch (error) {
      console.error('Error fetching student info:', error);
    }
  }

  async getReportInfo() {
    let secId = this.route.snapshot.params['secId'];
    let repId = this.route.snapshot.params['repId'];

    // console.log('getReportInfo - secId:', secId);
    // console.log('getReportInfo - repId:', repId);

    this.report = await this.reportService.readByIdAsync(secId, repId);

  }

}
